<template>
  <v-card>
    <div class="pa-2 px-4">
      <div class="pb-2">Challenges</div>
      <v-divider></v-divider>
      <div v-if="loading" class="my-3 text-center">
        <v-progress-circular indeterminate />
      </div>
      <div v-else>
        <Challange v-for="item of items" :key="item.id" :item="item" />
      </div>
    </div>
    <v-divider></v-divider>
    <v-btn small v-if="!loading" block to="/challenges">View All</v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Challenge </v-card-title>
        <div class="pa-4">
          <v-text-field outlined dense flat label="Title"></v-text-field>
          <v-autocomplete
            deletable-chips
            multiple
            small-chips
            solo
            flat
            dense
            outlined
            label="Genre"
            :items="getGenre"
          ></v-autocomplete>
          <v-text-field outlined dense flat label="Description"></v-text-field>
          <v-text-field
            type="date"
            outlined
            dense
            flat
            label="Deadline"
          ></v-text-field>
          <v-btn color="primary" block @click="dialog = false">Submit</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import Challange from '../Challange.vue';
export default {
  components: { Challange },
  name: "challenges",
  props: ["loading", "items"],
  data() {
    return {
      dialog: false,
    };
  },
  computed:{
    ...mapGetters([
      "getGenre"
    ])
  }
};
</script>

<style scoped>
</style>